import {CommonFilter} from '../common.filter';
import {Article} from './articles.model';

export interface ArticlesFilter extends CommonFilter {
  // Sorting
  sortBy?: string;
  descending?: boolean;

  // Population
  // Use 'createdBy:email;institution' to populate and select from the populated object.
  populate?: ('subjectAreas' | 'topics' | 'createdBy' | string)[];
  select?: (keyof Article | string)[];

  // Filter (New and safely in usage)
  q?: string; // Search string

  // Origin institution (not related to institutionRestrictions)
  institution?: string | 'mine';
  topics?: string[]; // Kategorien
  topicFilterType?: 'and' | 'or'; // filter by topics with AND or OR logic
  subjectAreas?: string[]; // Fachrichtungen
  federalStates?: string[]; // Bundesländer
  institutionKinds?: string[]; // Art der Institution

  only?: string; // Filter for only specific articles
  drafts?: boolean; // Include drafts

  // These require the institution/federalState/institutionKind to be in the institutionRestrictions/federalStateRestrictions/institutionKindRestrictions array
  onlyForInstitution?: string | 'mine';
  onlyForFederalState?: string | 'mine';
  onlyForInstitutionKind?: string | 'mine';

  // These require the institution/federalState/institutionKind to be in the institutionRestrictions/federalStateRestrictions/institutionKindRestrictions array
  // if it is set, otherwise it will be ignored
  visibleForInstitution?: string | 'mine';
  visibleForFederalState?: string | 'mine';
  visibleForInstitutionKind?: string | 'mine';

  createdBy?: string | 'me';

  // For Home page -> registerDate must be in the future
  hasOpenRegistration?: boolean;

  // For Article Creation -> check whether an article has the same links
  links?: string[];
}

export function parseArticleQuery(filter: ArticlesFilter, params: any) {
  if (+params.pageSize) {
    filter.pageSize = +params.pageSize;
  }
  if (+params.selectedPage) {
    filter.selectedPage = +params.selectedPage;
  }
  if (params.sortBy) {
    filter.sortBy = params.sortBy;
  }
  if (params.descending) {
    filter.descending = params.descending === 'true';
  }
  if (params.q) {
    filter.q = params.q;
  }
  if (params.topics) {
    filter.topics = params.topics.split(',');
  }
  if (params.subjectAreas) {
    filter.subjectAreas = params.subjectAreas.split(',');
  }
  if (params.federalStates) {
    filter.federalStates = params.federalStates.split(',');
  }
  if (params.only !== undefined) { // can be empty string
    filter.only = params.only;
  }
  if (params.topicFilterType !== undefined) {
    filter.topicFilterType = params.topicFilterType;
  }
}

export function writeArticleQuery(filter: ArticlesFilter): Record<string, string | string[] | number | boolean | undefined> {
  const {topics, subjectAreas, federalStates, institutionKinds, ...rest} = filter;

  return {
    ...rest,
    topics: topics?.join(','),
    subjectAreas: subjectAreas?.join(','),
    federalStates: federalStates?.join(','),
    institutionKinds: institutionKinds?.join(','),
  };

}
